import React, { FC } from "react"
import styled from "styled-components"
import { device } from "../../styles/media"

const FooterContainer = styled.footer`
  width: 100%;
  height: 72px;
  background: #010101;
  padding: 0 120px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  position: absolute;
  bottom: 0;
  @media ${device.laptop} {
    padding: 0 50px;
  }
  @media ${device.mobileL} {
    height: auto;
    padding: 20px;
    flex-direction: column;
  }
  .address {
    @media ${device.mobileL} {
      max-width: 170px;
      text-align: center;
      margin-bottom: 8px;
    }
  }
  .contacts {
    display: flex;
    @media ${device.mobileL} {
      height: auto;
      align-items: center;
      flex-direction: column;
      p {
        margin-bottom: 8px;
      }
      p:first-child {
        margin-right: 0;
      }
    }
    a {
      text-decoration: none;
      color: #fff;
    }
    p:first-child {
      margin-right: 38px;
      @media ${device.mobileL} {
        margin-right: 0;
        margin-bottom: 8px;
      }
    }
  }
`

export const Footer: FC<{
  address: string
  email: string
  phoneNumber: string
}> = ({ address, email, phoneNumber }) => {
  return (
    <FooterContainer>
      <p className="address">{address}</p>
      <div className="contacts">
        <p className="mail">
          <a href={`mailto:${email}`}>{email}</a>
        </p>
        <p className="phone">
          <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
        </p>
      </div>
    </FooterContainer>
  )
}
